/* Becquet Voiture : fiche produit « nouvelle ère » (octobre 2026).
   - Sélecteurs de variantes en étapes (pastilles, vignettes photo, liste de véhicules avec recherche),
     écart de prix par choix, choix du véhicule obligatoire avant l'ajout au panier.
   - Pilote les pastilles et sélecteurs de Turbo (sections.js > selectCallback reste le moteur).
   - Prix en médaille, prix au panier avec la remise automatique, bouton animé, image qui vole vers le panier.
   - Livraison offerte (barre de progression selon le panier réel), date de livraison estimée (politique d'expédition).
   - Accordéons : description repliable, outil de compatibilité, copie des références OEM.
   Sans JavaScript, la fiche Turbo d'origine reste utilisable. */
(function () {
  'use strict';
  /* Textes traduisibles : window.BVN_T est rendu par product-form avec les clés de langue bvn.js.* ;
     à défaut, le texte français d'origine. F remplace {x} sans motifs $ spéciaux. */
  function T(k, d) { var t = window.BVN_T; return (t && t[k]) || d; }
  function F(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return k in o ? o[k] : m; }); }

  /* Nom de l'option « véhicule » (rendu choix obligatoire) : français, anglais et allemand (les noms d'options sont traduits). */
  var VEH = /(mod[eè]le?l?\b|model|ann[ée]e|\byears?\b|jahr|compatib|kompatib|v[ée]hicule|vehicle|fahrzeug|g[ée]n[ée]ration|generation|ch[aâ]ssis|chassis|plateforme|platform|plattform|choisir|choose|w[aä]hlen|motorisation|engine|motor)/i;
  var IMG = /(couleur|color|colour|farbe|finition|finish|ausf[uü]hrung|oberfl|style|stil|mati[eè]re|material|motif|muster|logo|design|aspect|teinte)/i;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Pourcentage affiché partout de la même façon (−14 % en français et en allemand, −14% en anglais). */
  function pctTxt(n) { return String(T('pct', '−# %')).replace('#', n); }
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function money(c) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        var f = document.body.getAttribute('data-money-format') || '{{amount_with_space_separator}} €';
        var s = String(Shopify.formatMoney(c, f)).replace(/<[^>]+>/g, '');
        if (/\d/.test(s)) return s;
      }
    } catch (e) {}
    return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }
  function moneyShort(c) {
    var a = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (a && a !== 'EUR') return money(c);
    return c % 100 === 0 ? (c / 100).toLocaleString('fr-FR') + ' €' : money(c);
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function fire(node, type) {
    if (window.jQuery) window.jQuery(node).trigger(type);
    else node.dispatchEvent(new Event(type, { bubbles: true }));
  }
  function norm(s) {
    return String(s || '').toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  }
  function scrollToEl(node) {
    var top = node.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  }
  function addBiz(d, n) {
    d = new Date(d.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  var CAR = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 15l1.6-5.1A2 2 0 0 1 6.5 8.5h11a2 2 0 0 1 1.9 1.4L21 15v3a1 1 0 0 1-1 1h-1.5a1 1 0 0 1-1-1v-1h-11v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="7" cy="14.5" r="1.2" fill="currentColor"/><circle cx="17" cy="14.5" r="1.2" fill="currentColor"/></svg>';
  var TICK = '<svg class="bvn-val__tick" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var INFO = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="M12 11v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="12" cy="8" r="1" fill="currentColor"/></svg>';

  /* Panier : un seul appel par page */
  var cartPromise = null;
  function getCart() {
    if (!cartPromise) {
      cartPromise = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cartPromise;
  }

  function init(root) {
    if (root.__bvn) return;
    root.__bvn = true;

    var product;
    try { product = JSON.parse(root.getAttribute('data-product')); } catch (e) { return; }
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form || !product || !product.variants) return;
    root.classList.add('bvn-js');

    var variants = product.variants;
    var names = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('input.quantity');
    var atc = form.querySelector('[data-bvn-atc]');
    var auto = +root.getAttribute('data-bvn-pct') || 0;
    var free = +root.getAttribute('data-bvn-free') || 9900;
    var fee = +root.getAttribute('data-bvn-fee') || 995;
    var foreignCur = false;
    /* Hors devise de la boutique : seuil et frais convertis. Shopify.currency.rate contient l'ajustement de change du marché (environ 2 %),
       mais le seuil de livraison offerte est converti au taux de base (mesuré pour 99 € : US ≈ 110,4 $, GB ≈ 82,9 £, CA ≈ 154,5 $).
       On retire donc cet ajustement, puis on arrondit à l'unité SUPÉRIEURE : jamais de livraison offerte annoncée trop tôt. */
    var cur0 = (window.Shopify && Shopify.currency) || {};
    if (cur0.active && cur0.active !== (root.getAttribute('data-shop-currency') || 'EUR')) {
      var rate = parseFloat(cur0.rate) || 1;
      foreignCur = true;
      free = Math.ceil(free * rate / 1.02 / 100) * 100;
      fee = Math.ceil(fee * rate / 1.02 / 100) * 100;
    }
    var fromLink = /[?&]variant=\d+/.test(location.search);
    var tiersData = null;
    try { tiersData = JSON.parse(root.getAttribute('data-bvn-tiers') || 'null'); } catch (e) {}

    function byId(id) { for (var k = 0; k < variants.length; k++) if (String(variants[k].id) === String(id)) return variants[k]; return null; }
    function match(opts) {
      for (var k = 0; k < variants.length; k++) {
        var v = variants[k], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function valuesOf(i) {
      var out = [];
      variants.forEach(function (v) { if (out.indexOf(v.options[i]) < 0) out.push(v.options[i]); });
      return out;
    }
    function qty() { var q = parseInt(qtyInput && qtyInput.value, 10); return q > 0 ? q : 1; }
    function cartPrice(p, q) {
      var pct = auto;
      if (q && tiersData) tiersData.forEach(function (t) { if (q >= t.q && t.p > pct) pct = t.p; });
      return pct > 0 ? p - Math.round(p * pct / 100) : p;
    }

    var cur = byId(idInput && idInput.value) || variants[0];
    var galTouched = false; /* le client a touché la galerie ou choisi une variante : on ne remet plus la photo d'entrée */
    var sel = cur.options.slice();
    /* Une seule variante : rien à choisir, quel que soit le nom de l'option (le véhicule reste indiqué par la pastille et l'onglet Compatibilité). */
    var single = variants.length === 1;
    var chosen = names.map(function (n, i) { return fromLink || !VEH.test(n) || valuesOf(i).length < 2; });

    /* ---------- Sélecteurs ---------- */
    var box = root.querySelector('[data-bvn-opts]');
    var groups = [];
    if (box && !single) {
      names.forEach(function (name, i) {
        var vals = valuesOf(i);
        var isVeh = VEH.test(name);
        var imgs = {};
        var nImg = 0, distinct = {};
        if (IMG.test(name) && !isVeh) {
          vals.forEach(function (val) {
            for (var k = 0; k < variants.length; k++) {
              var fi = variants[k].featured_image;
              if (variants[k].options[i] === val && fi && fi.src) { imgs[val] = fi.src; nImg++; distinct[fi.src] = 1; break; }
            }
          });
        }
        var mode = (nImg === vals.length && Object.keys(distinct).length > 1 && vals.length <= 12) ? 'img'
          : ((isVeh && vals.length > 3) || vals.length > 10) ? 'list' : 'pill';

        var g = el('div', 'bvn-opt');
        g.setAttribute('data-i', i);
        var head = el('div', 'bvn-opt__head');
        head.appendChild(el('span', 'bvn-opt__step', String(i + 1)));
        head.appendChild(el('span', 'bvn-opt__name', name));
        var valLabel = el('span', 'bvn-opt__val');
        head.appendChild(valLabel);
        g.appendChild(head);

        var search = null, chipBar = null, chipKey = '', applyFilter = function () {};
        if (vals.length > 8) {
          search = el('input', 'bvn-opt__search');
          search.type = 'search';
          search.placeholder = isVeh ? T('search_veh', 'Tapez votre modèle, code ou année') : T('search', 'Rechercher');
          search.setAttribute('aria-label', T('filter', 'Filtrer : ') + name);
          search.setAttribute('enterkeyhint', 'search');
          g.appendChild(search);
        }

        /* Longue liste de diamètres (ex. « 54 mm … ») : puces de filtre rapide au-dessus de la liste. */
        var chipOf = function (val) { var m = /^\s*(\d+(?:[.,]\d+)?)\s*(mm|cm)\b/i.exec(val); return m ? m[1] + ' ' + m[2].toLowerCase() : ''; };
        if (mode === 'list' && !isVeh) {
          var order = [], covered = 0;
          vals.forEach(function (val) { var c = chipOf(val); if (c) { covered++; if (order.indexOf(c) < 0) order.push(c); } });
          order.sort(function (a, b) { return parseFloat(a.replace(',', '.')) - parseFloat(b.replace(',', '.')); });
          if (order.length > 1 && covered >= vals.length * 0.8) {
            chipBar = el('div', 'bvn-chips');
            chipBar.setAttribute('role', 'group');
            chipBar.setAttribute('aria-label', T('filter', 'Filtrer : ') + name);
            ['' ].concat(order).forEach(function (c) {
              var cb = el('button', 'bvn-chip2' + (c === '' ? ' is-on' : ''), c === '' ? T('all', 'Tous') : c);
              cb.type = 'button';
              cb.__c = c;
              cb.addEventListener('click', function () {
                chipKey = c;
                each(chipBar.querySelectorAll('.bvn-chip2'), function (x) { x.classList.toggle('is-on', x === cb); x.setAttribute('aria-pressed', x === cb ? 'true' : 'false'); });
                applyFilter();
              });
              cb.setAttribute('aria-pressed', c === '' ? 'true' : 'false');
              chipBar.appendChild(cb);
            });
            g.appendChild(chipBar);
          }
        }

        var list = el('div', 'bvn-vals' + (mode === 'list' ? ' bvn-vals--list' : mode === 'img' ? ' bvn-vals--img' : ''));
        list.setAttribute('role', 'radiogroup');
        list.setAttribute('aria-label', name);
        var buttons = [];
        vals.forEach(function (val) {
          var b = el('button', 'bvn-val' + (mode === 'img' ? ' bvn-val--img' : ''));
          b.type = 'button';
          b.setAttribute('role', 'radio');
          b.__val = val;
          if (mode === 'img') {
            var im = document.createElement('img');
            im.src = imgs[val] + (imgs[val].indexOf('?') > -1 ? '&' : '?') + 'width=220';
            im.alt = '';
            im.loading = 'lazy';
            im.width = 110; im.height = 110;
            b.appendChild(im);
            b.appendChild(el('span', 'bvn-val__label', val));
            b.title = val;
          } else if (mode === 'list' && isVeh) {
            var ico = el('span', 'bvn-val__car'); ico.innerHTML = CAR; b.appendChild(ico);
            var m = /^(.*?)\s*\(([^)]*)\)\s*$/.exec(val);
            var main = el('span', 'bvn-val__main');
            main.appendChild(el('span', '', m ? m[1] : val));
            if (m) main.appendChild(el('em', '', m[2]));
            b.appendChild(main);
          } else {
            b.appendChild(el('span', 'bvn-val__label', val));
          }
          var d = el('span', 'bvn-val__delta');
          b.appendChild(d);
          b.__delta = d;
          if (mode !== 'img') b.insertAdjacentHTML('beforeend', TICK);
          b.addEventListener('click', function () { pick(i, val); });
          list.appendChild(b);
          buttons.push(b);
        });
        g.appendChild(list);
        var empty = el('p', 'bvn-opt__empty', T('empty', 'Aucun choix ne correspond. Effacez la recherche ou consultez l\'onglet Compatibilité.'));
        g.appendChild(empty);

        applyFilter = function () {
          var q = search ? norm(search.value) : '', shown = 0;
          buttons.forEach(function (b) { var ok = (!q || norm(b.__val).indexOf(q) > -1) && (!chipKey || chipOf(b.__val) === chipKey); b.hidden = !ok; if (ok) shown++; });
          empty.style.display = shown ? 'none' : 'block';
        };
        if (search) search.addEventListener('input', applyFilter);
        if (isVeh && vals.length > 1) {
          var help = el('p', 'bvn-opt__help');
          help.innerHTML = INFO + '<span>' + T('help', 'Choisissez exactement votre version : la pièce est fabriquée pour elle. Un doute ? Ouvrez l\'onglet « Compatibilité véhicule » plus bas.') + '</span>';
          g.appendChild(help);
        }
        box.appendChild(g);
        groups.push({ i: i, node: g, buttons: buttons, label: valLabel, isVeh: isVeh });
      });
      root.classList.add('bvn-ready');
    }

    function refresh() {
      var need = groups.some(function (g) { return !chosen[g.i]; });
      root.classList.toggle('bvn-need', need);
      var stk = document.getElementById('bv-sticky-atc');
      if (stk) stk.classList.toggle('is-need', need);
      groups.forEach(function (g) {
        var i = g.i;
        g.label.textContent = chosen[i] ? sel[i] : T('to_choose', 'À choisir');
        g.label.classList.toggle('is-missing', !chosen[i]);
        g.node.classList.toggle('is-done', !!chosen[i]);
        g.buttons.forEach(function (b) {
          var test = sel.slice(); test[i] = b.__val;
          var v = match(test);
          var on = chosen[i] && sel[i] === b.__val;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.classList.toggle('is-off', !v || !v.available);
          var txt = '';
          if (v && cur && v.price !== cur.price && !(sel[i] === b.__val)) txt = (v.price > cur.price ? '+ ' : '− ') + moneyShort(Math.abs(v.price - cur.price));
          b.__delta.textContent = txt;
          b.title = !v ? T('unavail', 'Combinaison indisponible avec vos autres choix') : '';
        });
      });
    }

    function pick(i, val) {
      galTouched = true;
      sel[i] = val;
      chosen[i] = true;
      var v = match(sel);
      if (!v || !v.available) {
        var best = null, bestScore = -1;
        variants.forEach(function (cand) {
          if (cand.options[i] !== val) return;
          var s = cand.available ? 1000 : 0;
          for (var j = 0; j < sel.length; j++) if (cand.options[j] === sel[j]) s += (sel.length - j) * 10;
          if (s > bestScore) { bestScore = s; best = cand; }
        });
        if (best) sel = best.options.slice();
        v = match(sel);
      }
      if (!v) { refresh(); return; }
      var g = groups[i];
      if (g) g.node.classList.remove('is-attn');
      syncTurbo(v);
      setVariant(v, true);
      /* La photo de la galerie suit la variante choisie : un seul ordre, donné après celui de Turbo (sections.js). */
      syncGallery(v);
      setTimeout(function () { syncGallery(v); }, 90);
      setTimeout(function () { syncGallery(v); }, 450);
    }

    function syncGallery(v) {
      var fi = v && v.featured_image;
      var gal = document.querySelector('.js-product-page-gallery .js-product-gallery');
      if (!fi || !gal) return;
      var fk = window.Flickity && Flickity.data ? Flickity.data(gal) : null;
      if (!fk || !fk.cells) return;
      for (var k = 0; k < fk.cells.length; k++) {
        var im = fk.cells[k].element.querySelector('img[data-image-id]');
        if (im && String(im.getAttribute('data-image-id')) === String(fi.id)) {
          if (fk.selectedIndex !== k) fk.select(k, false, true);
          return;
        }
      }
    }

    function syncTurbo(v) {
      var sos = form.querySelectorAll('select.single-option-selector');
      var last = null;
      v.options.forEach(function (val, j) {
        each(form.querySelectorAll('.swatch[data-option-index="' + j + '"] input[type="radio"]'), function (r) {
          if (r.value === val) r.checked = true;
        });
        var s = sos[j];
        if (s && s.value !== val) { s.value = val; last = s; }
      });
      if (last) fire(last, 'change');
      else if (!sos.length) {
        /* Pas de sélecteurs Turbo : on simule le clic sur la pastille de la dernière option. */
        var j = v.options.length - 1;
        each(form.querySelectorAll('.swatch[data-option-index="' + j + '"] input[type="radio"]'), function (r) {
          if (r.value === v.options[j]) fire(r, 'change');
        });
      }
      if (idInput && String(idInput.value) !== String(v.id)) {
        idInput.value = v.id;
        if (idInput.tagName === 'SELECT') fire(idInput, 'change');
      }
    }

    /* ---------- Prix ---------- */
    var pr = root.querySelector('[data-bvn-price]');
    var q = function (s) { return root.querySelector(s); };
    var nowEl = q('[data-bvn-now]'), wasEl = q('[data-bvn-was]'), badge = q('[data-bvn-badge]'), save = q('[data-bvn-save]'), autoEl = q('[data-bvn-auto]'), atcPrice = q('[data-bvn-atc-price]');

    function setVariant(v, bump) {
      cur = v;
      sel = v.options.slice();
      if (pr) {
        nowEl.textContent = v.price > 0 ? money(v.price) : T('free', 'Gratuit');
        var cmp = v.compare_at_price && v.compare_at_price > v.price;
        wasEl.textContent = cmp ? money(v.compare_at_price) : '';
        if (badge) {
          badge.hidden = !cmp;
          badge.textContent = cmp ? pctTxt(Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price)) : '';
        }
        save.textContent = cmp ? T('save', 'Vous économisez ') + money(v.compare_at_price - v.price) : '';
        if (autoEl) autoEl.textContent = money(cartPrice(v.price));
        pr.classList.toggle('bvn-price--soldout', !v.available);
        if (bump && !reduce) { pr.classList.remove('is-bump'); void pr.offsetWidth; pr.classList.add('is-bump'); }
      }
      updateQty();
      refresh();
      var st = document.querySelector('.bv-sticky-atc__price');
      if (st) {
        var m = st.querySelector('.money:not(.was)'), w = st.querySelector('.was');
        if (m) m.textContent = money(v.price);
        if (w) w.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      }
      tiersRender();
    }

    function updateQty() {
      if (atcPrice) atcPrice.textContent = cur && cur.available && cur.price > 0 ? money(cur.price * qty()) : '';
      ship();
      updateQtyMarks();
    }

    /* Turbo peut changer la variante de lui-même (lien, image) : on se recale sur son bloc prix. */
    var legacy = root.querySelector('.bvn-legacy .current_price');
    if (legacy && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var v = byId(idInput && idInput.value);
        if (v && v !== cur) setVariant(v, true);
      }).observe(legacy, { childList: true, subtree: true, characterData: true });
    }
    if (qtyInput) {
      qtyInput.addEventListener('input', updateQty);
      qtyInput.addEventListener('change', updateQty);
      each(form.querySelectorAll('.js-change-quantity'), function (b) { b.addEventListener('click', function () { setTimeout(updateQty, 30); }); });
    }

    /* ---------- Livraison offerte et date estimée ---------- */
    var shipBox = root.querySelector('[data-bvn-ship]'), shipTxt = root.querySelector('[data-bvn-ship-txt]'), shipFill = root.querySelector('[data-bvn-ship-fill]');
    /* Texte de départ (avant la réponse du panier) : mêmes montants que le calcul, pas ceux convertis ailleurs au taux brut. */
    if (foreignCur && shipTxt) each(shipTxt.querySelectorAll('[data-bvn-eur]'), function (e) {
      e.__bvn = 1;
      e.textContent = e.hasAttribute('data-bvn-up') ? moneyShort(free) : money(fee);
    });
    var cartTotal = null;
    function ship() {
      if (!shipBox || cartTotal === null || !cur) return;
      var add = cur.available ? cartPrice(cur.price, qty()) * qty() : 0;
      var total = cartTotal + add;
      var pct = Math.max(4, Math.min(100, total / free * 100));
      shipFill.style.width = pct + '%';
      shipBox.classList.toggle('is-free', total >= free);
      if (cartTotal >= free) shipTxt.innerHTML = F(T('ship_done', '<strong>Votre livraison est offerte</strong> : votre panier dépasse {x}.'), {x: moneyShort(free)});
      else if (total >= free) shipTxt.innerHTML = T('ship_with', 'Avec cet article, <strong>la livraison vous est offerte</strong>.');
      else shipTxt.innerHTML = F(T('ship_left', 'Plus que <strong>{x}</strong> pour la livraison offerte (sinon {fee}).'), {x: money(free - total), fee: money(fee)});
    }
    getCart().then(function (c) { cartTotal = c && typeof c.total_price === 'number' ? c.total_price : 0; ship(); });

    /* Pas de date de livraison estimée : les délais publiés se contredisent (politique d'expédition et
       pages Infos livraison / FAQ). On affiche seulement l'expédition sous 48 h, écrite dans le Liquid. */

    /* ---------- Paliers de quantité (offre, si le propriétaire l'active) ---------- */
    var tiersBox = root.querySelector('[data-bvn-tiersbox]');
    var tiers = null;
    try { tiers = JSON.parse(root.getAttribute('data-bvn-tiers') || 'null'); } catch (e) {}
    function tiersRender() {
      if (!tiersBox || !tiers || !tiers.length || !cur) return;
      /* Article offert (0 €) : pas de paliers de remise. */
      if (!(cur.price > 0)) { tiersBox.style.display = 'none'; return; }
      tiersBox.style.display = '';
      var base = cartPrice(cur.price);
      var html = '<p class="bvn-tiers__title">' + T('tiers_title', 'Achetez-en plus, payez moins<small>Remise sur tout le panier, produits mélangés acceptés</small>') + '</p>';
      html += '<button type="button" class="bvn-tier" data-q="1"><b>' + T('one_item', '1 article') + '</b><span class="bvn-tier__pct">' + pctTxt(auto) + '</span><span class="bvn-tier__amt"><i>' + money(base) + '</i></span></button>';
      tiers.forEach(function (t, k) {
        var unit = cur.price - Math.round(cur.price * t.p / 100);
        html += '<button type="button" class="bvn-tier" data-q="' + t.q + '"' + (k === tiers.length - 1 ? ' data-plus="1"' : '') + '><b>' + t.q + (k === tiers.length - 1 ? T('and_more', ' et +') : T('items', ' articles')) + '</b><span class="bvn-tier__pct">' + pctTxt(t.p) + '</span><span class="bvn-tier__amt"><i>' + money(unit) + '</i>' + T('each', ' pièce') + '</span></button>';
      });
      tiersBox.innerHTML = html;
      each(tiersBox.querySelectorAll('.bvn-tier'), function (b) {
        b.addEventListener('click', function () { if (qtyInput) { qtyInput.value = b.getAttribute('data-q'); updateQty(); } });
      });
      updateQtyMarks();
    }
    function updateQtyMarks() {
      each(root.querySelectorAll('.bvn-tier'), function (t) {
        var tq = +t.getAttribute('data-q');
        t.classList.toggle('is-on', t.getAttribute('data-plus') ? qty() >= tq : qty() === tq);
      });
    }

    /* ---------- Bouton d'achat ---------- */
    if (atc) {
      atc.addEventListener('pointerdown', function (e) {
        if (reduce || atc.disabled) return;
        var r = atc.getBoundingClientRect(), size = Math.max(r.width, r.height);
        var rip = el('span', 'bvn-ripple');
        rip.style.width = rip.style.height = size + 'px';
        rip.style.left = (e.clientX - r.left - size / 2) + 'px';
        rip.style.top = (e.clientY - r.top - size / 2) + 'px';
        atc.appendChild(rip);
        setTimeout(function () { if (rip.parentNode) rip.parentNode.removeChild(rip); }, 700);
      });
      /* Le clic est filtré par le script en ligne de product-form (capture sur window, avant l'appli
         de panier Vanga qui intercepte l'ajout) : il appelle root.__bvnBlock puis root.__bvnCelebrate. */
      root.__bvnBlock = function () {
        for (var k = 0; k < groups.length; k++) {
          var g = groups[k];
          if (!chosen[g.i]) {
            g.node.classList.remove('is-attn'); void g.node.offsetWidth; g.node.classList.add('is-attn');
            scrollToEl(g.node);
            var first = g.node.querySelector('.bvn-opt__search') || g.node.querySelector('.bvn-val');
            if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (x) {} }, 450);
            return true;
          }
        }
        return false;
      };
      root.__bvnCelebrate = celebrate;
    }
    function celebrate() {
      if (!atc || atc.classList.contains('is-adding')) return;
      atc.classList.add('is-adding');
      setTimeout(function () { atc.classList.remove('is-adding'); }, 2200);
      if (navigator.vibrate) { try { navigator.vibrate(14); } catch (e) {} }
      if (reduce) return;
      var src = document.querySelector('.product_section .flickity-slider .is-selected img, .product_section .product_gallery img, .product_section img');
      var target = document.querySelector('.bv-bottomnav a[href*="/cart"], #header .cart_container a, .cart_container a.mini_cart, a[href="/cart"]');
      if (!src || !target) return;
      var a = src.getBoundingClientRect(), b = target.getBoundingClientRect();
      if (!b.width) return;
      var fly = document.createElement('img');
      fly.className = 'bvn-fly';
      fly.src = src.currentSrc || src.src;
      fly.alt = '';
      var sx = (a.left + a.width / 2) - 36, sy = Math.max(10, a.top + Math.min(a.height, 300) / 2) - 36;
      fly.style.left = sx + 'px';
      fly.style.top = sy + 'px';
      document.body.appendChild(fly);
      requestAnimationFrame(function () {
        fly.style.transform = 'translate(' + ((b.left + b.width / 2 - 36) - sx) + 'px,' + ((b.top + b.height / 2 - 36) - sy) + 'px) scale(.25) rotate(-12deg)';
        fly.style.opacity = '.2';
      });
      setTimeout(function () { if (fly.parentNode) fly.parentNode.removeChild(fly); }, 900);
    }

    /* ---------- Accordéons ---------- */
    var desc = root.querySelector('[data-bvn-desc]'), more = root.querySelector('[data-bvn-more]');
    if (desc && more) {
      var check = function () {
        if (desc.classList.contains('is-open')) return;
        if (desc.scrollHeight > desc.clientHeight + 40) more.hidden = false;
        else desc.classList.add('is-open');
      };
      if (document.readyState === 'complete') check(); else window.addEventListener('load', check);
      setTimeout(check, 60);
      more.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        more.textContent = open ? T('less', 'Réduire la description') : T('more', 'Lire toute la description');
        if (!open) scrollToEl(desc.closest('details') || desc);
      });
    }

    each(root.querySelectorAll('[data-bvn-open]'), function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById(a.getAttribute('data-bvn-open'));
        if (!t) return;
        e.preventDefault();
        if (t.tagName === 'DETAILS') t.open = true;
        scrollToEl(t);
      });
    });

    var cp = root.querySelector('[data-bvn-compat]');
    if (cp) {
      var more2 = cp.querySelector('[data-bvn-cp-more]');
      if (more2) more2.addEventListener('click', function () {
        each(cp.querySelectorAll('[data-bvn-cp-extra]'), function (li) { li.hidden = false; });
        more2.hidden = true;
      });
      each(cp.querySelectorAll('[data-bvn-copy]'), function (b) {
        b.addEventListener('click', function () {
          var t = b.getAttribute('data-bvn-copy');
          var done = function () { b.classList.add('is-copied'); setTimeout(function () { b.classList.remove('is-copied'); }, 1600); };
          if (navigator.clipboard) navigator.clipboard.writeText(t).then(done, function () {}); else done();
        });
      });
      var cpSel = cp.querySelector('[data-bvn-cp-sel]'), cpRes = cp.querySelector('[data-bvn-cp-res]');
      if (cpSel && cpRes) {
        cpSel.addEventListener('change', function () {
          var o = cpSel.options[cpSel.selectedIndex];
          cpRes.className = 'bvn-cp__res';
          cpRes.textContent = '';
          if (!cpSel.value) return;
          if (cpSel.value === 'none') {
            cpRes.classList.add('is-ko');
            cpRes.innerHTML = T('not_listed', 'Votre véhicule n\'est pas listé : ne commandez pas sans vérification. Envoyez-nous votre numéro VIN, nous cherchons la bonne pièce pour vous. ');
            var mail = document.createElement('a');
            mail.href = 'mailto:info@becquet-voiture.com?subject=' + encodeURIComponent(T('mail_subject', 'Compatibilité : ') + product.title);
            mail.textContent = T('write_advisor', 'Écrire au conseiller');
            cpRes.appendChild(mail);
            return;
          }
          cpRes.classList.add('is-ok');
          cpRes.appendChild(document.createTextNode(T('compatible', 'Compatible : ') + o.textContent + '.'));
          var optName = cp.getAttribute('data-option');
          var oi = optName ? names.indexOf(optName) : -1;
          if (oi > -1) {
            var gen = norm(o.getAttribute('data-gen')), mod = norm(o.getAttribute('data-modele')), yrs = norm(o.getAttribute('data-annees'));
            var vals = valuesOf(oi), hit = null;
            [gen, yrs, mod].some(function (key) {
              if (!key) return false;
              for (var k = 0; k < vals.length; k++) if (norm(vals[k]).indexOf(key) > -1) { hit = vals[k]; return true; }
              return false;
            });
            if (hit) {
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.textContent = F(T('choose_q', 'Choisir « {x} »'), {x: hit});
              btn.addEventListener('click', function () {
                pick(oi, hit);
                var g = groups.filter(function (x) { return x.i === oi; })[0];
                if (g) scrollToEl(g.node);
              });
              cpRes.appendChild(document.createElement('br'));
              cpRes.appendChild(btn);
            }
          }
        });
      }
    }

    /* ---------- Apparition au défilement ---------- */
    var rv = root.querySelectorAll('[data-bvn-reveal]');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      each(rv, function (n) { io.observe(n); });
    } else each(rv, function (n) { n.classList.add('is-in'); });

    setVariant(cur, false);
    /* La galerie s'ouvre sur la photo principale du produit (Turbo la plaçait sur la photo de la première variante), sauf si le client arrive par un lien de variante. */
    var galWrap = document.querySelector('.js-product-page-gallery');
    if (galWrap) ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) { galWrap.addEventListener(ev, function () { galTouched = true; }, true); });
    if (!fromLink) {
      [0, 350, 900, 1800, 3200].forEach(function (ms) {
        setTimeout(function () {
          if (galTouched) return;
          var gal0 = document.querySelector('.js-product-page-gallery .js-product-gallery');
          var fk0 = gal0 && window.Flickity && Flickity.data ? Flickity.data(gal0) : null;
          if (fk0 && fk0.cells && fk0.selectedIndex !== 0) fk0.select(0, false, true);
        }, ms);
      });
    }
    if (fromLink) { [900, 1800].forEach(function (ms) { setTimeout(function () { syncGallery(cur); }, ms); }); }
    /* Pas de défilement automatique de la galerie (il changeait la photo sous les yeux du client). */
    [1200, 2600].forEach(function (ms) {
      setTimeout(function () {
        var gal = document.querySelector('.js-product-page-gallery .js-product-gallery');
        var fk = gal && window.Flickity && Flickity.data ? Flickity.data(gal) : null;
        if (fk && fk.player && fk.stopPlayer) fk.stopPlayer();
      }, ms);
    });
  }

  /* ---------- Bloc d'avis : visionneuse, « voir plus » ---------- */
  /* Widget d'avis Judge.me v3 : on lit le manifeste de l'extension Judge.me pour charger ses styles,
     puis on importe son module et on le monte sur notre conteneur (première visite comme navigation InstantClick). */
  var jdgmMod = null;
  function jdgmLoad() {
    if (jdgmMod) return jdgmMod;
    var base = window.jdgm && jdgm.CDN_BASE_URL;
    if (!base) return null;
    jdgmMod = fetch(base + 'manifest.json').then(function (r) { return r.json(); }).then(function (m) {
      var seen = {};
      (function css(k) {
        var c = m[k];
        if (!c || seen[k]) return;
        seen[k] = 1;
        (c.css || []).forEach(function (f) {
          var u = base + f;
          if (document.querySelector('link[href="' + u + '"]')) return;
          var l = document.createElement('link');
          l.rel = 'stylesheet';
          l.href = u;
          document.head.appendChild(l);
        });
        (c.imports || []).forEach(css);
      })('review-widget/main.js');
      /* Shopify minifie les assets du thème et réécrit import() : on passe par un petit script module. */
      return new Promise(function (ok, ko) {
        var s = document.createElement('script');
        s.type = 'module';
        s.onerror = ko;
        window.addEventListener('bvn:jdgm', function () { ok({ ReviewWidgetManager: window.__bvnRWM }); }, { once: true });
        s.textContent = 'import{ReviewWidgetManager as R}from' + JSON.stringify(base + m['review-widget/ReviewWidgetManager.js'].file) +
          ';window.__bvnRWM=R;window.dispatchEvent(new Event("bvn:jdgm"));';
        document.head.appendChild(s);
      });
    });
    jdgmMod.catch(function () { jdgmMod = null; });
    return jdgmMod;
  }
  /* Judge.me affiche « Traduction en cours… » sans fin quand sa traduction ne répond pas : après 7 s on masque ce libellé
     (l'avis reste lisible dans sa langue d'origine). Les réglages Judge.me ne sont pas touchés. */
  function staleTranslate(el) {
    var n = 0;
    (function tick() {
      n++;
      each(el.querySelectorAll('.jdgm-translate-button.loading'), function (b) {
        if (!b.__t0) b.__t0 = Date.now();
        else if (Date.now() - b.__t0 > 7000) b.classList.add('bvn-stale');
      });
      if (n < 14 && document.body.contains(el)) setTimeout(tick, 3000);
    })();
  }
  function mountJdgm(el, tries) {
    if (el.__bvnJd) return;
    var p = jdgmLoad();
    if (!p) {
      /* Le script Judge.me de la page n'est pas encore chargé : on réessaie un peu plus tard. */
      if ((tries || 0) < 20) setTimeout(function () { mountJdgm(el, (tries || 0) + 1); }, 300);
      return;
    }
    el.__bvnJd = true;
    /* Le widget lit ses données dans jdgm.data.reviewWidget[id produit] ; une entrée vide = aucun avis. */
    var pid = el.getAttribute('data-product-id'), data = {};
    try { data = JSON.parse(el.getAttribute('data-bvn-jd') || '{}') || {}; } catch (x) {}
    if (!data.image_url) {
      var og = document.querySelector('meta[property="og:image:secure_url"]');
      if (og) data.image_url = og.content;
    }
    jdgm.data = jdgm.data || {};
    jdgm.data.reviewWidget = jdgm.data.reviewWidget || {};
    jdgm.data.reviewWidget[pid] = data;
    /* Dates des avis au format français (le réglage Judge.me de la boutique est au format américain). */
    if (window.jdgmSettings && jdgmSettings.review_date_format === 'mm/dd/yyyy') jdgmSettings.review_date_format = 'dd/mm/yyyy';
    p.then(function (mod) {
      if (!document.body.contains(el)) return;
      var started = new mod.ReviewWidgetManager(el).initialize();
      staleTranslate(el);
      return started;
    }).catch(function () { el.__bvnJd = false; });
  }

  function initAvis(sec) {
    if (sec.__bvn) return;
    sec.__bvn = true;
    var more = sec.querySelector('[data-bvn-rv-more]');
    if (more) more.addEventListener('click', function () {
      each(sec.querySelectorAll('[data-bvn-rv-extra]'), function (a) { a.hidden = false; });
      more.hidden = true;
    });
    var jd = sec.querySelector('[data-bvn-jdgm]');
    if (jd) mountJdgm(jd);
    /* Avis de la boutique : si le widget v3 est monté, notre bouton ouvre sa fenêtre d'avis.
       Sinon, le formulaire Judge.me (widget/form.js) n'est chargé par Judge.me que sur
       les liens d'invitation ; on le charge au premier clic sur « Écrire un avis » puis on rejoue le clic. */
    var write = sec.querySelector('[data-bvn-write]');
    if (write) write.addEventListener('click', function (e) {
      var jb = sec.querySelector('.bvn-jdgm .jm-action-buttons__button.jm-button--primary');
      if (jb) {
        e.preventDefault();
        e.stopImmediatePropagation();
        jb.click();
        return;
      }
      if (document.querySelector('.jdgm-write-review-modal') || write.__loading) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!window.jdgm || !jdgm.loadScript || !jdgm.CDN_HOST) return;
      write.__loading = true;
      write.classList.add('is-loading');
      try { jdgm.loadCSS(jdgm.widgetPath('form.css')); } catch (x) {}
      jdgm.loadScript(jdgm.CDN_HOST + 'widget/form.js', function () {
        var t0 = Date.now();
        (function wait() {
          if (document.querySelector('.jdgm-write-review-modal') || Date.now() - t0 > 6000) {
            write.classList.remove('is-loading');
            write.click();
            return;
          }
          setTimeout(wait, 150);
        })();
      });
    }, true);

    var lb = sec.querySelector('[data-bvn-lb]');
    if (!lb || typeof lb.showModal !== 'function') return;
    var img = lb.querySelector('[data-bvn-lb-img]'), cap = lb.querySelector('[data-bvn-lb-cap]');
    var arts = Array.prototype.slice.call(sec.querySelectorAll('[data-bvn-rvi]'));
    var flat = [];
    arts.forEach(function (a, ri) {
      (a.getAttribute('data-pics') || '').split('|').filter(Boolean).forEach(function (u, pi) { flat.push({ ri: ri, pi: pi, u: u }); });
    });
    var pos = 0;
    function show(k) {
      if (!flat.length) return;
      pos = (k + flat.length) % flat.length;
      var f = flat[pos], a = arts[f.ri];
      img.src = f.u + '_960x960.jpg';
      img.alt = F(T('photo_alt', 'Photo d\'un acheteur, {i} sur {n}'), {i: pos + 1, n: flat.length});
      var txt = a.querySelector('.bvn-rv__txt'), who = a.querySelector('.bvn-rv__who'), st = a.getAttribute('data-r');
      cap.innerHTML = '';
      var b = document.createElement('b');
      b.textContent = st + ' / 5 · ' + (who ? who.textContent : '');
      cap.appendChild(b);
      if (txt) { cap.appendChild(document.createElement('br')); cap.appendChild(document.createTextNode(txt.textContent)); }
    }
    function open(ri, pi) {
      for (var k = 0; k < flat.length; k++) if (flat[k].ri === ri && flat[k].pi === pi) { show(k); break; }
      if (!lb.open) lb.showModal();
    }
    sec.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-bvn-rv]');
      if (!b) return;
      open(+b.getAttribute('data-bvn-rv'), +b.getAttribute('data-bvn-pi'));
    });
    lb.querySelector('[data-bvn-lb-close]').addEventListener('click', function () { lb.close(); });
    lb.querySelector('[data-bvn-lb-prev]').addEventListener('click', function () { show(pos - 1); });
    lb.querySelector('[data-bvn-lb-next]').addEventListener('click', function () { show(pos + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(pos - 1);
      if (e.key === 'ArrowRight') show(pos + 1);
    });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(pos + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* ---------- Passe 2 (29/10/2026) ---------- */
  /* Une promesse rejetée avec « false » dans le widget d'avis Judge.me remplissait la console d'une erreur sans conséquence : on l'absorbe. */
  if (!window.__bvpRej) {
    window.__bvpRej = 1;
    window.addEventListener('unhandledrejection', function (e) { if (e && e.reason === false) e.preventDefault(); });
  }
  /* Compteur « 3 / 9 » sur la photo (mobile : les vignettes sont retirées pour que le prix et le titre restent dans la première vue). */
  function galleryCount() {
    var wrap = document.querySelector('.js-product-page-gallery');
    var gal = wrap && wrap.querySelector('.js-product-gallery');
    if (!gal || gal.__bvpG) return;
    var fk = window.Flickity && Flickity.data ? Flickity.data(gal) : null;
    if (!fk || !fk.cells || fk.cells.length < 2) {
      if ((gal.__bvpTry = (gal.__bvpTry || 0) + 1) < 15) setTimeout(galleryCount, 400);
      return;
    }
    gal.__bvpG = 1;
    var old = wrap.querySelector('.bvp-gcount');
    if (old) old.parentNode.removeChild(old);
    var c = el('div', 'bvp-gcount');
    c.setAttribute('aria-hidden', 'true');
    wrap.appendChild(c);
    var upd = function () { c.textContent = (fk.selectedIndex + 1) + ' / ' + fk.cells.length; };
    fk.on('select', upd);
    upd();
  }
  /* Loupe plein écran : textes traduits (la bibliothèque les écrit en anglais). */
  function lightboxLang() {
    var f = window.jQuery && jQuery.fancybox && jQuery.fancybox.defaults;
    if (!f || f.__bvpLang) return;
    f.__bvpLang = 1;
    f.i18n = f.i18n || {};
    f.i18n.bvp = {
      CLOSE: T('fb_close', 'Fermer'), NEXT: T('fb_next', 'Suivant'), PREV: T('fb_prev', 'Précédent'), ZOOM: T('fb_zoom', 'Zoom'),
      ERROR: T('fb_error', 'Cette photo ne peut pas être chargée. Réessayez plus tard.'),
      PLAY_START: T('fb_next', 'Suivant'), PLAY_STOP: T('fb_close', 'Fermer'), FULL_SCREEN: T('fb_zoom', 'Zoom'),
      THUMBS: T('fb_zoom', 'Zoom'), DOWNLOAD: T('fb_zoom', 'Zoom'), SHARE: T('fb_zoom', 'Zoom')
    };
    f.lang = 'bvp';
  }
  function passe2() {
    galleryCount();
    lightboxLang();
  }

  function boot() {
    each(document.querySelectorAll('[data-bvn]'), init);
    each(document.querySelectorAll('[data-bvn-avis]'), initAvis);
    passe2();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* Turbo (InstantClick) remplace la page sans recharger le script. */
  if (window.InstantClick && InstantClick.on) InstantClick.on('change', boot);
  window.bvnInit = boot;
})();
